// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2QAcP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2mUns"};